<template>
  <div class="vehicle-selector-add-node">
    <oie-base-action
      v-if="!isOpen"
      ref="toggler"
      theme="outlined-black"
      :aria-controls="id"
      :aria-expanded="isOpen"
      @click="isOpen = true">
      {{ toggleTextComputed }}
      <template #iconAppend>
        <oie-base-icon icon="add" size="xs"></oie-base-icon>
      </template>
    </oie-base-action>
    <div v-else :id="id" class="vehicle-selector-add-node__content">
      <p>{{ tStatic('selectVehicleSlideInAddNodeText') }}</p>
      <oie-base-input ref="input" v-model="newNode"></oie-base-input>
      <oie-action-wrapper>
        <template #left>
          <oie-base-action theme="outlined-black" @click="handleAddNewNode">
            {{ tStatic('confirm') }}
          </oie-base-action>
          <oie-base-action theme="skeleton" @click="isOpen = false">
            {{ tStatic('cancel') }}
          </oie-base-action>
        </template>
      </oie-action-wrapper>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick, watch, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    level: {
      type: String,
      default: '0'
    },
    context: {
      type: Object,
      required: true
    },
    toggleText: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit, root }) {
    const id = `vehicle-selector-add-node-${props.level}`
    const input = ref(null)
    const toggler = ref(null)
    const isOpen = ref(false)
    const newNode = ref('')

    const toggleTextComputed = computed(() => props.toggleText || root.tStatic('selectVehicleSlideInAddNode'))

    watch(isOpen, async (newVal) => {
      await nextTick()
      newVal ? input.value.$el.focus() : toggler.value.$el.focus()
    })

    function handleAddNewNode() {
      const parentCode = props.context.nodeData.value[props.level].node.code === 'root' ? null : props.context.nodeData.value[props.level].node.code
      props.context.addNode({ name: newNode.value, parentCode }, props.level)
      newNode.value = ''
    }
    return {
      id,
      isOpen,
      newNode,
      handleAddNewNode,
      toggleTextComputed
    }
  }
})
</script>

<style lang="scss">
.vehicle-selector-add-node__content {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
  align-items: flex-start;
}
</style>
